<section class="about section" id="about-us">
  <div class="shell-container about__grid reveal" appRevealOnScroll="80ms">
    <div class="about__media">
      <div class="about__image-wrap">
        <img
          [src]="content.imageSrc"
          [alt]="content.imageAlt"
          class="about__image"
          loading="lazy"
        />
      </div>
    </div>

    <div class="about__content">
      <div class="badge about__badge">{{ content.badge }}</div>
      <h2>{{ content.heading }}</h2>
      <p class="about__lede">{{ content.lede }}</p>
      <p class="about__body">{{ content.body }}</p>

      <div class="about__highlights">
        <div class="about__item" *ngFor="let item of content.highlights">
          <span class="about__dot"></span>
          <div>
            <p class="about__item-title">{{ item.title }}</p>
            <p class="about__item-text">{{ item.description }}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
